import {Component, Input, OnInit} from '@angular/core';
import {AppUser} from "../../../../../framework/model/core/appuser/appuser";
import {OrderService} from "../../../../services/OrderService";
import {Events} from "../../../../../framework/providers/events";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {ModelClasses} from "../../../../model/modelClasses";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent implements OnInit {
    @Input()
    public modelId;
    @Input()
    public title:boolean = true;

    public appuser: AppUser;
    // public models: Array<AppUser> = [];
    public options: object = {};
    public tabs: object = {'value': null, "data": []};
    public filters;
    public companyData;

    constructor(public orderService: OrderService, public events: Events, public modelProvider: ModelProvider, public modelClasses: ModelClasses,
                public tools:ModelToolsProvider) {
        this.appuser = this.orderService.getAppUser();
    }

    ngOnInit() {
        console.log("INVOICEE!!!")
        this.filters = {'company':this.modelId};

        this.modelProvider.custom('getInvoiceInterface', {'setPrefix': false, 'company':this.modelId, 'mode':'api_types'}).then((res) => {
            if (res['res']) {
                this.setInterfaceData(res);
            } else {
                this.setDefaultData();
            }
        });

        this.setTab(false);
    }

    setInterfaceData(res) {
        let models = res['models'];
        for (let modelData of models) {
            let cls = this.modelClasses.getClass(modelData['modelName']);
            let model = new cls({});
            let fields = modelData['fields'] ? modelData['fields'] : model.fields;
                let data = {
                'value': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'model': model,
                'title': modelData['name'] ? modelData['name'] : modelData['modelName'],
                'checked': true,
                'modelName': modelData['modelName'],
                'display': 'table',
                'header': fields,
                'fields': fields,
                'calcable':modelData['calcable'],
                'checkedData':{'checked':{}, 'data':{}, 'balance':0, 'amount':0},
                'filters': modelData['filters'],
                'options': {},
                'models': [],
                'prefix': modelData['modelName']
            };
            this.tabs['data'].push(data);
            if(!this.tabs['value']) this.tabs['value'] = data['value'];
        }

        this.companyData = res['company_data']
    }

    setDefaultData() {
        this.tabs['value'] = 'checks';
        this.tabs['data'] = [
            {
                'value': 'checks',
                'title': 'checks',
                'checked': true,
                'modelName': 'bandObligoChecks',
                'display': 'table',
                'header': ['payDate', 'cardNum', 'qprice', 'currency'],
                'fields': ['payDate', 'cardNum', 'qprice', 'code'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'checksList'
            },
            {
                'value': 'openDebt',
                'title': 'openDebt',
                'checked': true,
                'modelName': 'bandObligoFncitems',
                'display': 'card',
                'fields': ['balDate', 'ivnum', 'fncPatname', 'details', 'price', 'fncDate'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'openDebtList'
            },
            {
                'value': 'withoutCharge',
                'title': 'withoutCharge',
                'checked': false,
                'modelName': 'bandObligoTrans',
                'display': 'table',
                'header': ['curDate', 'docno', 'price', 'currency'],
                'fields': ['curDate', 'docno', 'price', 'currencyCode'],
                'filters': {},
                'options': {},
                'models': [],
                'prefix': 'withoutChargetList'
            }
        ]
    }

    setTab(event = null) {
        if (event) {
            this.tabs['value'] = event['detail']['value'];
        }
    }

    setChecked(tab, model)
    {
        let amount = 0;
        let balance = 0;
        let checked = tab['checkedData']['checked'];
        tab['checkedData']['data'][model.data.id] = model;
        for(let key in checked)
        {
            if(checked[key])
            {
                amount++;
                balance+=parseFloat(tab['checkedData']['data'][key].data.balance);
                console.log(balance);
            }
        }
        tab['checkedData']['amount'] = amount;
        tab['checkedData']['balance'] = balance;
    }

    refresh(prefix) {
        this.events.publish(prefix + '_updateFilter', {'refresh': true});
    }

}
